<template>
  <div class="main-container p-3">
    <KidHeader :profileId="profileId" :serialNumber="serialNumber" />

    <!-- Back to Home -->
    <div class="back-home text-left mb-3">
      <a class="text-black" href="javascript:void(0)" @click="$router.push({ path: '/reports', query: { profileId, serialNumber } })">
        <i class="fas fa-arrow-left"></i> <b>Back to Reports</b>
      </a>
    </div>

    <!-- Weekly Activity Report -->
    <div v-if="reportDetail && Object.keys(reportDetail).length" class="report-body">
      <h2 class="section-title">📊 {{ reportDetail.reportTitle }}</h2>

      <h3 class="section-subtitle">Total Screen Time This Week: {{ reportDetail.totalScreenTime }}</h3>

      <!-- Daily Usage -->
      <h3 class="section-subtitle">📅 Daily Usage</h3>
      <table class="usage-table">
        <tr v-for="(day, index) in reportDetail.dailyUsage" :key="index">
          <td class="text-left">{{ day.name }}</td>
          <td class="text-right">{{ day.time }}</td>
        </tr>
      </table>

      <!-- Bar Chart -->
      <h3 class="section-subtitle">📈 Day-wise Usage Chart</h3>
      <p class="section-description">Visual summary of screen time per day</p>
      <img :src="reportDetail.barChartUrl" alt="Day-wise Usage Chart" class="report-image" />

      <!-- Pie Chart -->
      <h3 class="section-subtitle">🧩 Category Usage Breakdown</h3>
      <p class="section-description">Visual summary of time spent by category</p>
      <img :src="reportDetail.pieChartUrl" alt="Category Pie Chart" class="report-image" />

      <!-- Top Apps -->
      <h3 class="section-subtitle">🔝 Top Used Applications</h3>
      <div class="app-list">
        <div
          v-for="(app, index) in reportDetail.topApplications"
          :key="index"
          class="app-row"
        >
          <div class="app-info">
            <img :src="app.icon" width="20" height="20" :alt="app.name" class="app-icon" />
            <span>{{ app.name }}</span>
          </div>
          <div>{{ app.time }}</div>
        </div>
      </div>

      <!-- Top Categories -->
      <h3 class="section-subtitle">🧩 Top Categories</h3>
      <ol class="category-list">
        <li
          v-for="(category, index) in reportDetail.topCategories"
          :key="index"
          class="category-row"
        >
          <span>{{ category.name }}</span>
          <span>{{ category.time }}</span>
        </li>
      </ol>
    </div>

    <KidFooter />
  </div>
</template>

<script>
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import KidsService from '../../services/KidsService'

export default {
  name: 'Change Password',
  components: {
    KidHeader,
    KidFooter,
  },
  data() {
    return {
      profileId: this.$route.query.profileId,
      serialNumber: this.$route.query.serialNumber,
      id: this.$route.query.id,
      isDisabled: false,
      reportDetail: {},
    }
  },
  methods: {
    async getReportDetail() {
      const data = {
        id: this.id,
        serialNumber: this.serialNumber,
        profileId: this.profileId,
      }

      await KidsService.getReportDetail(data)
        .then((response) => {
          this.reportDetail = response.data.data
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg)
          this.isDisabled = false
        })
    },
  },
  beforeMount() {
    this.getReportDetail()
  },
}
</script>

<style scoped>
.report-body {
  font-family: Arial, sans-serif;
  color: #333;
  font-size: 14px;
}

.section-title {
  font-size: 18px;
  color: #004aad;
  font-weight: bold;
  text-align: left;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-top: 30px;
}

.section-description {
  font-size: 13px;
  color: #666;
  margin-bottom: 10px;
}

.usage-table {
  width: 100%;
  font-size: 14px;
  margin-bottom: 20px;
  border-collapse: collapse;
}

.usage-table td {
  padding: 4px 0;
}

.text-left {
  text-align: left;
  padding-left: 12px;
}

.text-right {
  text-align: right;
  padding-right: 12px;
}

.report-image {
  max-width: 100%;
  height: auto;
  border: 1px solid #ddd;
  padding: 6px;
  margin-bottom: 20px;
}

.app-list {
  margin-bottom: 30px;
}

.app-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px dashed #ddd;
}

.app-info {
  display: flex;
  align-items: center;
}

.app-icon {
  margin-right: 8px;
}

.category-list {
  padding-left: 20px;
  margin: 0 0 30px 0;
  list-style-position: inside;
}

.category-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px dashed #ddd;
}
</style>
